// extracted by mini-css-extract-plugin
export default {"divider":"list-for-task_divider__UJk6G","option_text":"list-for-task_option_text__zB4JN"};